import domReady from '../helpers/dom-ready';

domReady(() => {
  if (!document || !document.documentElement) {
    return;
  }

  const { classList } = document.documentElement;

  if (classList.contains('no-js')) {
    classList.remove('no-js');
  }
  if (!classList.contains('js')) {
    classList.add('js');
  }

  function addTouchClass() {
    if (!classList.contains('touch')) {
      classList.add('touch');
    }
    if (classList.contains('no-touch')) {
      classList.remove('no-touch');
    }
    document.removeEventListener('touchstart', addTouchClass);
    document.removeEventListener('mousemove', addNoTouchClass); // eslint-disable-line no-use-before-define
  }

  function addNoTouchClass() {
    if (classList.contains('touch')) {
      classList.remove('touch');
    }
    if (!classList.contains('no-touch')) {
      classList.add('no-touch');
    }
    document.removeEventListener('mousemove', addNoTouchClass);
    document.removeEventListener('touchstart', addTouchClass);
  }

  document.addEventListener('mousemove', addNoTouchClass);
  document.addEventListener('touchstart', addTouchClass);
});
